/**
 * Wasp.js
 * The Wasp Hero class
 */

import { Game } from "pixi_core";
import { Hero } from "./Hero";
import { DEFAULT_WASP_DAMAGE_INCREASE, DEFAULT_WASP_DURATION, GameEvents } from "../Constants";

export class Wasp extends Hero {
    /**
     * @public
     * @param {Object} heroData
     */
    constructor(heroData) {
        super(heroData);

        /** @private @type {Number} */
        this._abilityDuration = Game.utils.assertNumber(heroData.AbilityDuration, DEFAULT_WASP_DURATION);

        /** @private @type {Number} */
        this._damageIncrease = Game.utils.assertNumber(heroData.DamageIncrease, DEFAULT_WASP_DAMAGE_INCREASE);
    }

    /**
     * @public
     * @override
     */
    useAbility() {
        super.useAbility();
        Game.audio.playSfx("IDSND_ABIL_WASP_ACTIVATE");
        Game.fire(GameEvents.eHERO_ABILITY_WASP, this._abilityDuration, this._damageIncrease);
    }
}
